import type { StateTagWrapperProps } from "./state-tag.type";

import { REFERENTIAl_STATES_ENDPOINTS } from "@/entities/referential/referential-states";

import { StateTag } from "./state-tag.component";

export const StateTagWrapper = ({
  type,
  value,
  asText,
}: StateTagWrapperProps) => {
  /**
   * Type of {type} should be a value of REFERENTIAl_STATES_ENDPOINTS directly
   * but we need to migrate to TS all files that use <StateTag /> component before.
   * Meanwhile, we force the cast of the type.toUpperCase() to a key of REFERENTIAl_STATES_ENDPOINTS.
   * */
  const key = type.toUpperCase() as keyof typeof REFERENTIAl_STATES_ENDPOINTS;
  const endpoint =
    key in REFERENTIAl_STATES_ENDPOINTS
      ? REFERENTIAl_STATES_ENDPOINTS[key]
      : undefined;

  if (!endpoint) return null;

  return <StateTag endpoint={endpoint} value={value} asText={asText} />;
};
